import React from 'react';
import { useInitData } from 'queries/initial-data';

const InitialAppFetch = () => {
  useInitData();

  return <></>;
};

export { InitialAppFetch };
